import { Controller } from "@hotwired/stimulus"

/**
 * Zeigt ein Overlay über dem Turbo-Frame „matches“, solange ein Request für diesen Frame läuft
 * (Filter-Submit, Pagination, Reset-Link, initiales Laden per src).
 */
export default class extends Controller {
  static targets = ["overlay"]
  static values = { frameId: String }

  connect() {
    this.beforeFetch = this.beforeFetch.bind(this)
    this.onFrameLoad = this.onFrameLoad.bind(this)
    this.onFetchError = this.onFetchError.bind(this)
    this.onSubmitEnd = this.onSubmitEnd.bind(this)

    document.addEventListener("turbo:before-fetch-request", this.beforeFetch)
    document.addEventListener("turbo:frame-load", this.onFrameLoad)
    document.addEventListener("turbo:fetch-request-error", this.onFetchError)
    document.addEventListener("turbo:submit-end", this.onSubmitEnd)
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-request", this.beforeFetch)
    document.removeEventListener("turbo:frame-load", this.onFrameLoad)
    document.removeEventListener("turbo:fetch-request-error", this.onFetchError)
    document.removeEventListener("turbo:submit-end", this.onSubmitEnd)
  }

  frameHeaderFromFetch(event) {
    const headers = event.detail?.fetchOptions?.headers
    if (!headers) return null
    if (typeof headers.get === "function") {
      return (
        headers.get("Turbo-Frame") ||
        headers.get("turbo-frame") ||
        headers.get("Turbo-frame")
      )
    }
    return (
      headers["Turbo-Frame"] ||
      headers["turbo-frame"] ||
      headers["Turbo-frame"]
    )
  }

  beforeFetch(event) {
    if (this.frameHeaderFromFetch(event) === this.frameIdValue) {
      this.show()
    }
  }

  onFrameLoad(event) {
    if (event.target?.id === this.frameIdValue) {
      this.hide()
    }
  }

  onFetchError(event) {
    if (this.frameHeaderFromFetch(event) === this.frameIdValue) {
      this.hide()
    }
  }

  /**
   * Wenn turbo:frame-load nicht feuert (Fehler, abgebrochener Request, fehlendes Frame in der Antwort),
   * blieb das Overlay sichtbar und blockierte u. a. den Schnellfilter. Nach Ende der Formular-Übermittlung
   * für dieses Frame wieder freigeben.
   */
  onSubmitEnd(event) {
    const form = event.detail?.formSubmission?.formElement
    if (!(form instanceof HTMLFormElement)) return
    if (form.getAttribute("data-turbo-frame") !== this.frameIdValue) return
    this.hide()
  }

  show() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
    }
  }

  hide() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden")
    }
  }
}
